export function verifyAuth () {
  if (typeof localStorage.token !== 'undefined') {
    return localStorage.token
  } else {
    return false
  }
}

export function loginUser (param) {
  try {
    localStorage.setItem('token', param)
  } catch (e) {
    let storage = window.localStorage
    storage.setItem('token', param)
  }
}

export function logoutUser () {
  delete localStorage.token
}

export function getToken () {
  return localStorage.token
}



// WEBPACK FOOTER //
// ./src/components/Commons/Authentication.js